import React, { forwardRef } from "react"

const Overlay = forwardRef(({ caption, scroll }, ref) => {
  const items = [
    { title: "Diamond", description: "Diamond is a solid form of carbon with atoms arranged in a crystal structure called diamond cubic, known for its exceptional hardness." },
    { title: "Gemstone", description: "Diamonds are prized gemstones, valued for their brilliance, clarity, and rarity, often used in jewelry." },
    { title: "Crystal", description: "The diamond's crystal lattice gives it unmatched strength, making it the hardest naturally occurring substance known." },
    { title: "Carbon", description: "Diamonds form under high pressure and temperature deep within the Earth's mantle, composed entirely of carbon atoms." },
    { title: "Jewel", description: "Diamonds are cut and polished to enhance their sparkle, making them a centerpiece in fine jewelry." },
    { title: "Mineral", description: "As a mineral, diamond is prized for its thermal conductivity and optical dispersion, used in both industry and adornment." },
    { title: "Precious", description: "Diamonds are considered precious due to their rarity and beauty, often symbolizing wealth and eternity." }
  ]

  return (
    <div
      ref={ref}
      onScroll={(e) => {
        const scrollHeight = e.target.scrollHeight - window.innerHeight;
        scroll.current = scrollHeight > 0 ? Math.min(e.target.scrollTop / scrollHeight, 1) : 0;
        if (caption.current) {
          caption.current.innerText = scroll.current.toFixed(2);
        }
      }}
      className="scroll"
    >
      {items.map((item, index) => (
        <div key={index} style={{ height: index === 0 ? "400vh" : "200vh" }}>
          <div className="dot">
            <h1>{item.title}</h1>
            <p>{item.description}</p>
          </div>
        </div>
      ))}
      <span className="caption" ref={caption}>
        0.00
      </span>
    </div>
  )
})

export default Overlay
